export default "__VITE_ASSET__BXmAWJHm__"